import NCOSLogo from './NCOSLogo';

const LoginLogo = () => {
  return (
    <div style={{ alignSelf: 'center' }}>
      <NCOSLogo />
    </div>
  );
};

export default LoginLogo;
